"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateNumberRangeArray = void 0;
// Generate an array of integers, centered on MiddleValue, not reaching limit.
var generateNumberRangeArray = exports.generateNumberRangeArray = function generateNumberRangeArray(length, middleValue, limit) {
  return Array.from({
    length: length
  }, function (v, i) {
    var offset = Math.floor(length / 2);
    if (!middleValue || middleValue <= offset) {
      // Ascend starting at 0.
      return i;
    }
    if (limit && middleValue + offset >= limit) {
      // Descend starting at maximum.
      return limit - i - 1;
    }
    return middleValue + i - offset;
  }).sort(function (a, b) {
    return a - b;
  });
}; // Ensure numerical sorting (rather than default string).